import type { ComponentRegistry } from "@json-render/react";

import { ReportDateFromProps } from "@/components/ui/report/ReportDate/ReportDateSpec";
import { ReportFooterFromProps } from "@/components/ui/report/ReportFooter/ReportFooterSpec";
import { ReportHeaderFromProps } from "@/components/ui/report/ReportHeader/ReportHeaderSpec";
import { ReportHighlightFromProps } from "@/components/ui/report/ReportHighlight/ReportHighlightSpec";
import { ReportSectionFromProps } from "@/components/ui/report/ReportSection/ReportSectionSpec";
import { ReportTableOfContentsFromProps } from "@/components/ui/report/ReportTableOfContents/ReportTableOfContentsSpec";

/** Report components available at render time but not in the Herald prompt catalog. */
export const reportRendererRegistry: ComponentRegistry = {
  ReportDate: ReportDateFromProps,
  ReportFooter: ReportFooterFromProps,
  ReportHeader: ReportHeaderFromProps,
  ReportHighlight: ReportHighlightFromProps,
  ReportSection: ReportSectionFromProps,
  ReportTableOfContents: ReportTableOfContentsFromProps,
};
